export const RemoteDisplayBatchStatus = {
  IDLE: 'IDLE',
  START_WEIGHT: 'START WEIGHT',
  WEIGHT: 'WEIGHT',
  DISCHARGE: 'DISCHARGE',
  FINISH: 'FINISH',
};
